module.exports = __webpack_public_path__ + "img/logo-white-sl.b7ab010a.svg";